import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const ProductTypeSectionRoot = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$2',

  '@bp2': {
    gap: '$3',
  },
})

export const Cards = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  gap: '$2',

  '@bp2': {
    flexDirection: 'row',
    gap: '$3',
    justifyContent: 'center',
  },
})
